export default __webpack_public_path__ + "static/media/firebomb_alone.95e65c30.png";